import { useExperiences } from 'core/contexts/experience';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { formatCurrencyWithDecimals, PaymentPlatform } from '@utriper/core';
import { Box, Button, Grid2, Typography } from '@mui/material';
import { CheckboxTerms, TextInput } from '@utriper/core-ui';
import { Container, Label } from 'modules/Bookings/BookingNew/styles';
import { useBookingsV2 } from 'core/contexts/bookingV2';
import { useBookingWizard } from 'core/contexts/bookingWizard';
import { useState } from 'react';

// TODO: ADD EXPIRES AT!
const PaymentDialog = ({ paymentPlatformId, bookingData, onClose = () => {} }) => {
    const { i18n } = useTranslation();
    const { getExperienceTermsId } = useExperiences();
    const { confirmBooking, cancelBooking, submitting } = useBookingsV2();
    const { setIsSuccess } = useBookingWizard();
    const { payNow, payTotal, currency, expiresAt, termsToAccept = [], payment } = bookingData;
    const cashPlatforms = [PaymentPlatform.IDS.cash, PaymentPlatform.IDS.OperatorCash];
    const [isCancel, setIsCancel] = useState(false);

    const handleSubmit = async (values) => {
        const dataToSend = {
            paymentId: payment?.paymentId,
            paymentUID: values?.paymentUID,
            paymentPlatformId,
            sessionId: payment?.clientSecret,
            termsAccepted: termsToAccept,
        };

        const result = await confirmBooking(dataToSend);

        if (result?.status) {
            setIsSuccess(true);
        }
        onClose();
    };

    const handleCancel = async () => {
        const paymentId = payment?.paymentId;

        setIsCancel(true);
        const result = await cancelBooking(paymentId);

        if (result) {
            onClose();
        }
        setIsCancel(false);
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={() => {}}
            render={({ handleSubmit, form, values }) => {
                const handleCheck = (value) => {
                    form.change('termsAndConditions', value);
                };

                return (
                    <form onSubmit={handleSubmit}>
                        <Box mt={2}>
                            <Typography variant="h3" fontSize="20px" fontWeight={600}>
                                Pago de la Reserva
                            </Typography>

                            <Grid2 container size={12} justifyContent="space-between" alignItems="center" mt={2}>
                                <Typography fontSize={16}>Total:</Typography>
                                <Typography fontSize={16} fontWeight={600}>
                                    {formatCurrencyWithDecimals(payTotal, currency, i18n.language, 0)}
                                </Typography>
                            </Grid2>

                            <Grid2 container size={12} justifyContent="space-between" alignItems="center" mt={2}>
                                <Typography fontSize={16}>A pagar ahora:</Typography>
                                <Typography fontSize={16} fontWeight={600} sx={{ color: '#137DC5' }}>
                                    {formatCurrencyWithDecimals(payNow, currency, i18n.language, 0)}
                                </Typography>
                            </Grid2>

                            {!cashPlatforms.includes(paymentPlatformId) && (
                                <Container mt={2}>
                                    <Label>{`Codigo único de pago del ${PaymentPlatform.getTranslatedName(PaymentPlatform.types, paymentPlatformId, i18n.language)}`}</Label>
                                    <Field name="paymentUID" component={TextInput} label="" placeholder={`Ingresa el código único del ${PaymentPlatform.getTranslatedName(PaymentPlatform.types, paymentPlatformId, i18n.language)}`} />
                                </Container>
                            )}

                            {termsToAccept?.length > 0 && (
                                <Box mt={2}>
                                    <Field name="termsAndConditions" checked={values?.termsAndConditions} onChange={handleCheck} component={CheckboxTerms} termsToAccept={termsToAccept} onTermsClick={getExperienceTermsId} fileUrl={process.env.REACT_APP_CDN_URL} />
                                </Box>
                            )}

                            {/* Buttons */}
                            <Grid2 container gap={1.5} justifyContent={'flex-end'} mt={2}>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        border: '1px solid #13131340',
                                        color: '#131313',
                                        fontWeight: 600,
                                    }}
                                    loading={submitting && isCancel}
                                    disabled={submitting}
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        fontWeight: 600,
                                        color: 'white',
                                        backgroundColor: '#137DC5',
                                    }}
                                    loading={submitting && !isCancel}
                                    disabled={(termsToAccept?.length > 0 && !values?.termsAndConditions) || submitting}
                                    onClick={(e) => {
                                        return handleSubmit(e);
                                    }}
                                >
                                    Confirmar
                                </Button>
                            </Grid2>
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default PaymentDialog;
